<!-- The column of every report page, on the plant of the kit's AreaPage (src/product/areas/AreaPage.vue): the page
     fills the panel with a 24px margin, 24px between blocks, and only an ultrawide screen stops it, at 100rem. One
     scroll for the whole page (the Topbar stays above it); the title is the Topbar's breadcrumb (D-G2). -->
<template>
  <div
    class="h-full w-full min-w-0 overflow-auto bg-polaris-card px-4 py-6 text-polaris-foreground sm:px-6"
    data-reports-page
  >
    <div
      class="mx-auto grid w-full min-w-0 max-w-[100rem] grid-cols-[minmax(0,1fr)] gap-6 pb-6"
    >
      <router-view />
    </div>
  </div>
</template>
